<template>
    <headerVue></headerVue>
    <div id="container">
		<div class="sub_wrap">
            <subPageHeadVue></subPageHeadVue>
            <locationBarVue></locationBarVue>
            <contentVue></contentVue>
        </div>
    </div>
    <footerVue></footerVue>
    <goTopVue></goTopVue>
</template>

<script>
import headerVue from '@/components/en/common/Header.vue';
import subPageHeadVue from '@/components/en/common/Title.vue';
import locationBarVue from '@/components/en/common/LocationBar.vue';
import contentVue from '@/components/en/boards/BoardDetail.vue';
import footerVue from '@/components/en/common/Footer.vue';
import goTopVue from '@/components/en/common/GoTop.vue';

export default {
    components: {
        headerVue,
        subPageHeadVue,
        locationBarVue,
        contentVue,
        footerVue,
        goTopVue
    },
    data() {
        return {
            pageType: '',
            offsets: [],
        }
    },
    methods: {
       
    },
    computed: {

    },
    mounted() {
         
    }
}
</script>

<style>
    
</style>